import React from 'react';

import {facebook_1} from 'react-icons-kit/ikons/facebook_1'
import {mail} from 'react-icons-kit/ikons/mail'
import {map} from 'react-icons-kit/ikons/map'
import SvgIcon from 'react-icons-kit';
import GoogleMaps from '../GoogleMaps/GoogleMaps.js';




export class ContactBox extends React.Component {
  constructor(props){
    super(props);

 

    //State storage - should be hooked up with mongoose
   
   //We use OnLoadPost to get latest stored DB post. Intended to use with cancel button.
    this.state =  {
      showMap: false
    };

    //Bindings
    this.handleShowMap = this.handleShowMap.bind(this);
  }

handleShowMap() {
  if(this.state.showMap === false){
    this.setState({
      showMap: true
    });
  }
  else{
    this.setState({showMap: false});
  }
  }

    

     
render()
{



return(
      <div className="row ContactBox">
              <div className="cardContainer col-md-4 col-centered" >
              
        <a className="card expand" href="https://www.facebook.com/gamerlanmysen" target="_blank" rel="noopener noreferrer">
      <div className="card-block">
        <SvgIcon size={45} icon={facebook_1}/>
        <h4 className="card-title">Facebook</h4>
      </div>
    </a>
    </div>

    <div  className="cardContainer col-md-4 col-centered">
        <a onClick={this.handleShowMap} className="card expand">
      <div className="card-block">
      <SvgIcon size={45} icon={map}/>
      <h4 className="card-title">Veibeskrivelse</h4>
      </div>
    </a>
    </div>

    <div className="cardContainer col-md-4 col-centered" >

        <a className="card expand" href="mailto:post@gamerlan.no">
      <div className="card-block">
      <SvgIcon size={45} icon={mail}/>
      <h4 className="card-title">Epost</h4>
      </div>
    </a>
    </div>
           
    <GoogleMaps showMap={this.state.showMap} handleShowMap={this.handleShowMap} />

    

       </div>
        
    )};
}

export default ContactBox;



// WEBPACK FOOTER //
// ./src/Components/Contact/ContactBox.js